import { render, staticRenderFns } from "./distributoriCommerciali.vue?vue&type=template&id=985c7fd2&"
import script from "./distributoriCommerciali.vue.ts?vue&type=script&lang=ts&"
export * from "./distributoriCommerciali.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports